module.exports = __webpack_public_path__ + "static/img/5.777d552b.png";